import { actionTypes } from '../../constants';
import { fromJS } from 'immutable';

const {
  GET_CMA_DETAILS_SUCCESS,
  GET_CMA_DETAILS_FAILURE,
  UPDATE_CMA_DETAILS_SUCCESS,
  UPDATE_CMA_DETAILS_FAILURE,
  TOGGLE_MODAL,
  CLOSE_MODAL,
} = actionTypes;

export const initialState = fromJS({
  cmaAlert: {},
  isOpen: false,
  updateOverdraftError: false,
});

const cmaAlert = (state = initialState, action) => {
  switch (action.type) {
    case GET_CMA_DETAILS_SUCCESS:
      return state.set('cmaAlert', fromJS(action.payload));

    case GET_CMA_DETAILS_FAILURE:
      return state.set('cmaError', action.error);

    case UPDATE_CMA_DETAILS_SUCCESS:
      return state.set('cmaAlert', fromJS(action.payload));

    case UPDATE_CMA_DETAILS_FAILURE:
      return state.set('updateCmaError', action.error);

    case TOGGLE_MODAL:
      return state.set('isOpen', action.isOpen).set('overDraftType', action.overDraftType);

    case CLOSE_MODAL:
      return state.set('updateCmaError', action.updateOverdraftError);

    default:
      return state;
  }
};

export default cmaAlert;
